const swiperEls = document.querySelectorAll('.swiper');
swiperEls.forEach(swiperEl => {
  const delay = parseInt(swiperEl.dataset.delay);
  const swiper = new Swiper(swiperEl, {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: delay * 1000 || 5000,
    },
    loop: true,
  });
});
